import React, { useState, useEffect } from 'react';
import { Avatar, Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import axios from 'axios';
import { useAuth } from "../../../Context/store/context";
import globals from '../../../../globals';
import CreateUserForm from './CreateUserForm';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import HotelIcon from '@mui/icons-material/Hotel';
import RepeatIcon from '@mui/icons-material/Repeat';
import Typography from '@mui/material/Typography';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import PaymentsIcon from '@mui/icons-material/Payments';
import VisibilityIcon from '@mui/icons-material/Visibility';
const Customer = ({ onClose, name }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeTab, setActiveTab] = useState('Overview'); // Track active tab
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const [roolSection, setRoolSection] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    if (!getToken()) logoutuser();
    updateTitleAndIcon(globals.Customer.title, globals.Customer.icon);
  }, []);
  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getadminpackage`);
      console.log(response.data.Rool);

      if (Array.isArray(response.data.Rool)) {
        setRoolSection(response.data.Rool);
      } else {
        setRoolSection([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setRoolSection([]); // Handle error case
    }
  };
  const toggleDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    fetchRools();
  };
  useEffect(() => {
    fetchRools();
  }, []);
  console.log("roolSection", roolSection)
  console.log("selectedUser", selectedUser)
  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block", padding: "20px" }}>
      <div role="document">
        <div className="modal-content" style={{ height: "94vh", display: "flex", flexDirection: "row" }}>
          {/* Left Sidebar */}
          <div style={{ width: "25%", borderLeft: "1px solid gray" }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 50 }} aria-label="simple table">
                <div className="modal-header">
                  <h5 className="modal-title"></h5>
                  <button type="button" className="bg-primary" onClick={toggleDialog} style={{ color: "white" }}>
                    <PersonAddIcon />
                  </button>
                </div>
                <TableBody>
                  {name.map((row) => (
                    <TableRow
                      key={row.userId}
                      onClick={() => setSelectedUser(row)}
                      style={{ cursor: "pointer" }}
                    >
                      <TableCell align="left">
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Avatar sx={{ width: 32, height: 32, fontSize: "14px" }}>
                            {row.firstName?.charAt(0).toUpperCase()}
                            {row.lastName?.charAt(0).toUpperCase()}
                          </Avatar>
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                              {row.firstName} {row.lastName}
                            </span>
                            <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                              {row.contactNo || row.phoneNumber}
                            </span>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Right Section */}
          <div style={{ width: "75%" }}>
            <div className="modal-header">
              <h5 className="modal-title">
                {selectedUser ? `${selectedUser.firstName} ${selectedUser.lastName}` : 'Select a User'}
              </h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            {/* Tab Navigation */}
            <div style={{ display: "flex", flexDirection: "row", gap: "5%", padding: "10px", borderBottom: "1px solid gray" }}>
              <span
                onClick={() => setActiveTab('Overview')}
                style={{
                  cursor: "pointer",
                  color: activeTab === 'Overview' ? 'red' : 'black',
                  fontWeight: activeTab === 'Overview' ? 'bold' : 'normal',
                  borderBottom: activeTab === 'Overview' ? '2px solid red' : 'none'
                }}
              >
                Overview
              </span>

              
            </div>

            {/* Tab Content */}
            <div style={{ padding: "10px" }}>
              {selectedUser && activeTab === 'Overview' && (
                <div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <div style={{ borderRight: "1px solid gray", padding: "2%", width: "30%", display: "flex", gap: "8px", height: "80vh" }}>
                      <Avatar sx={{ width: 32, height: 32, fontSize: "14px" }}>
                        {selectedUser.firstName?.charAt(0).toUpperCase()}
                        {selectedUser.lastName?.charAt(0).toUpperCase()}
                      </Avatar>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          {selectedUser.firstName} {selectedUser.lastName}
                        </span>
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          {selectedUser.email}
                        </span>
                        <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          {selectedUser.contactNo || selectedUser.phoneNumber}
                        </span>
                       
                        <div style={{ display: "flex", gap: "8px", marginTop: "10%" }}>
                          <div >
                            <div >
                              <h5 className="modal-title">
                                Current Package
                              </h5>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                Name: {selectedUser.Package.Name}
                              </span>
                              {selectedUser.Package.imageCount && (
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  Image Count: {selectedUser.Package.imageCount}
                                </span>
                              )}
                              {selectedUser.Package.maxImageCount && (
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  Max Image Count: {selectedUser.Package.maxImageCount}
                                </span>
                              )}
                              {selectedUser.Package.videoCount && (
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  Video Count: {selectedUser.Package.videoCount}
                                </span>
                              )}
                              {selectedUser.Package.drive && (
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  Drive: {selectedUser.Package.drive}
                                </span>
                              )}

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div>
                    <Timeline position="alternate">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="left"
          variant="body2"
          color="text.secondary"
        >
        
          {selectedUser.RegistedDate}
         
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot style={{background:"red"}}>
            <PersonAddIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
            User
          </Typography>
          <Typography>Registerd</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="text.secondary"
        >
         
         {new Date(selectedUser.updateDate).toLocaleString('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
}).replace(/\//g, '-').replace(',', '')}


        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot style={{background:"red"}}>
            <BorderColorIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
            Edit
          </Typography>
          <Typography>Last update User Details</Typography>
        </TimelineContent>
      </TimelineItem>
      
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="left"
          variant="body2"
          color="text.secondary"
        >
          {selectedUser.PackageCreated}
         
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot style={{background:"red"}}>
            <PaymentsIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
            Package
          </Typography>
          <Typography>Package created</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="text.secondary"
        >
           {selectedUser.Packageexpire}
        </TimelineOppositeContent>
        <TimelineSeparator style={{color:"red"}}>
          <TimelineConnector />
          <TimelineDot style={{background:"red"}}>
          <PaymentsIcon />
          </TimelineDot>
          
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2,  }}>
          <Typography variant="h6" component="span">
            Exipre
          </Typography>
          <Typography>Package expired</Typography>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="left"
          variant="body2"
          color="text.secondary"
        >
        
        {new Date(selectedUser.passwordupdateDate).toLocaleString('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
}).replace(/\//g, '-').replace(',', '')}
         
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot style={{background:"red"}}>
            <VisibilityIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
            Password
          </Typography>
          <Typography>New Password Updated</Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>

                    </div>
                  </div>
                </div>
              )}


          

            </div>

          </div>
        </div>
      </div>
      {isDialogOpen && <CreateUserForm onClose={closeDialog} />}
    </div>
  );
};

export default Customer;
